import { ReactNode } from 'react';

import { Box, BoxProps } from '@mui/material';
import cx from 'clsx';

import styles from './GlowingIcon.module.scss';

type GlowingIconVariant = 'blue' | 'orange' | 'pink' | 'green';

interface GlowingIconProps extends Omit<BoxProps, 'children'> {
  children: ReactNode;
  variant?: GlowingIconVariant;
  rotation?: number;
}

const GlowingIcon = ({ children, variant = 'blue', rotation, className, style, ...rest }: GlowingIconProps) => (
  <Box
    className={cx(styles.container, styles[variant], className)}
    style={{
      ...(rotation !== undefined && ({ '--custom-rotation': `${rotation}deg` } as React.CSSProperties)),
      ...style,
    }}
    {...rest}
  >
    {children}
  </Box>
);

export default GlowingIcon;
